export default "__VITE_ASSET__GvZv089t__"